import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '../../_service/message-service';
import { AuthenticationService, UserService } from 'src/app/_services';
import { environment } from 'src/environments/environment';
import { UserInfoService } from 'src/app/_services/userInfo.service';
declare var $: any;
@Component({
  selector: 'telio-edit-vendor-service-request',
  templateUrl: './edit-vendor-service-request.component.html',
  styleUrls: ['./edit-vendor-service-request.component.scss']
})
export class EditVendorServiceRequestComponent implements OnInit {
  ticketId: any;
  ticketDetails: any;
  vendorEmail: any;
  commentsArray = [];
  email: any;
  id: any;
  dateTime: any;
  superReply: boolean = false;
  requestUpdateForm: UntypedFormGroup;
  tikIssue;
  tikUrl;
  tikDes;
  vendorReply;
  input;
  supportEmail = environment.branding.footer.supportEmail;

  constructor(private userservice: UserService,
    private toastr: SnackbarService,
    private route: Router,private authenticationService: AuthenticationService,
    readonly userInfoService: UserInfoService,
    public translate: TranslateService,
    private formBuilder: UntypedFormBuilder,
    readonly routed: ActivatedRoute) { }

  public vendor = { email: 'vendor@gmail.com', query: 'Payment related', date: '19/09/2021', description: 'How much time it takes to refund my money?' }
  public super = { email: 'contact@rikarica.com', date: '30/09/2021', query: 'Payment-related', description: 'This is the reply for your query' }

  ngOnInit(): void {
    this.routed.queryParams.subscribe(params => {
      this.ticketId = params['ticketid']
    })
    this.requestUpdateForm = this.formBuilder.group({
      description: [null, Validators.required]
    })
    this.listofvendorreply();
  }

  listofvendorreply() {
    this.userservice.getTicketById(this.ticketId).subscribe((resp: any) => {
      this.ticketDetails = resp;
      this.email = this.ticketDetails.vendorEmail;
      this.commentsArray = this.ticketDetails.comment
      this.tikIssue = this.ticketDetails.issuetype
      this.tikUrl = this.ticketDetails.url
      this.tikDes = this.ticketDetails.description
      this.dateTime=this.authenticationService.convert24HrTo12Hr(this.authenticationService.convertToLocalTime(this.ticketDetails.createdDate,this.userInfoService.userDetails.prefCountry))
      for (let i = 0; i < this.commentsArray.length; i++) {
        this.commentsArray[i]['superReply'] = this.superReply
        if (this.commentsArray[i].emailId == this.supportEmail) {
          this.commentsArray[i].superReply = true
        }
        this.commentsArray[i].timestamp = this.authenticationService.convert24HrTo12Hr(this.authenticationService.convertToLocalTime(this.commentsArray[i].timestamp,this.userInfoService.userDetails.prefCountry))
      }
    })
  }

  requestUpdate() {
    this.vendorReply = this.requestUpdateForm.value
    if (!this.requestUpdateForm.valid) {
      this.toastr.error(this.translate.instant('editServiceRequest.error'))
    }

    this.input = {
      "emailId": this.ticketDetails.vendorEmail,
      "comment": this.vendorReply.description,
      "ticketId": this.ticketDetails.id
    }
    
    this.userservice.UpdateTicket(this.input).subscribe((resp => {
      if (!!resp) {
        this.toastr.success(this.translate.instant('editServiceRequest.success'));
        this.routeBack();
      }
      else {
        this.toastr.error(this.translate.instant('editServiceRequest.error2'))
      }

    }))

  }

  viewScreenshot() {
    $("#viewAlert").modal('show');
  }

  routeBack() {
    this.route.navigate(['/dashboard/service-request', { routeID: this.routed.snapshot.paramMap.get('routeID') }]);
  }

}
